import { Helmet } from "react-helmet-async";

const SITE_NAME = "أمانة العاصمة المقدسة";
const DEFAULT_IMAGE = "/fav/apple-touch-icon.png";

/**
 * PageSEO — drop this at the top of any page component.
 *
 * Props:
 *   title       {string}  — page title (appended with site name)
 *   description {string}  — meta description (≤ 160 chars recommended)
 *   image       {string}  — absolute URL for Open Graph image (optional)
 *   noindex     {boolean} — set true for pages you don't want indexed
 */
const PageSEO = ({ title, description, image = DEFAULT_IMAGE, noindex = false }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type"        content="website" />
      <meta property="og:site_name"   content={SITE_NAME} />
      <meta property="og:title"       content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image"       content={image} />

      {/* Twitter Card */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image"       content={image} />
    </Helmet>
  );
};

export default PageSEO;
